module.exports = __webpack_public_path__ + "img/operaStateNo.5f5dff5a.png";